import { useEffect, useState } from "react";
import { Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Table, TableHead, TableBody, TableCell, TableRow, TextField } from "@mui/material";

import EditSquareIcon from '@mui/icons-material/EditSquare';
import EditOffIcon from '@mui/icons-material/EditOff';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import PeopleIcon from '@mui/icons-material/People';

import Obj2StrArr from './Obj2StrArr.js'
import dateFix from "./DateFix.js";

function MemberInfo(props) {
    const { uid, MemberData, MemberId, DbUpload, Members, setCuotas, offlineMembersUpdate, EscKeyStroke, readyToClose, Debits, debitsFiltering } = props;
    const [edit, setEdit] = useState(Object.keys(MemberData).length === 1);
    const [simpleView, setSimpleView] = useState(Object.keys(MemberData).length !== 1);
    const [modMemberData, setModMemberData] = useState({});
    const [groupAccordion, setGroupAccordion] = useState({});
    const [nextMember, setNextMember] = useState('');
    const [uploadEnabled, setUploadEnabled] = useState(false);
    const [noteEdit, setNoteEdit] = useState(false);
    const [modMemberNote, setModMemberNote] = useState(MemberData.notas || '');

    useEffect(() => {
        setModMemberNote(MemberData.notas || '');
    }, [MemberData.notas])

    useEffect(() => {
        if (!MemberData.socio && !modMemberData.socio && !nextMember) {
            let maxMember = 0;
            for (let k of Object.keys(Members || {}))
                if (Number(Members[k].socio || 0) > Number(maxMember)) maxMember = Members[k].socio;
            if (maxMember > 0) setNextMember('Sig: ' + (Number(maxMember) + 1));
        }
    }, [Members, MemberData, modMemberData, nextMember])

    useEffect(() => { if (MemberId === 'nuevo') setEdit(true) }, [MemberId])

    useEffect(() => {
        readyToClose(EscKeyStroke && (!edit && simpleView && !noteEdit));
        if (EscKeyStroke) {
            if (edit)
                setTimeout(() => setEdit(false), 15);
            else {
                setGroupAccordion({});
                setSimpleView(!!MemberId);
            }
            setNoteEdit(false);
        }
    }, [EscKeyStroke, edit, simpleView, noteEdit])


    function memberDelete() {
        let d = {};
        d[`/members/${MemberId}`] = null;
        DbUpload(d).then(r => r && offlineMembersUpdate());
        window.location.hash = '';
    }

    function storeMemberData() {
        let modData = { ...modMemberData },
            DNInumber = modData.documentonumero !== undefined ? modData.documentonumero : MemberData.documentonumero || '',
            newId = 'DNI' + DNInumber;

        if (!!modData.debitos) {
            let familyGroupDebits = [];
            [modData.debitos, familyGroupDebits] = debitsFiltering([...modData.debitos]);
            if (MemberData.grupo_familiar) {
                DbUpload(
                    Obj2StrArr(
                        { debitos: familyGroupDebits }
                        , `/members/FG-${MemberData.grupo_familiar}`
                    )
                ).then(r => r && setCuotas(`FG-${MemberData.grupo_familiar}`, undefined, familyGroupDebits)
                )
            }
        }

        if (newId !== MemberId && !Object.keys(Members).includes(newId)) {
            if (!modData.permisos) modData.permisos = {};
            modData.permisos[uid] = 'creo';
            window.location.hash = `socio?${newId}`;
        }
        DbUpload(Obj2StrArr(modData, `/members/${newId}`))
            .then(r => r && offlineMembersUpdate().then(() => {
                if (!!modData.debitos)
                    setCuotas(newId, undefined, modData.debitos);
            })
            )
        setEdit(false);
    }

    function storeMemberNote() {
        DbUpload(Obj2StrArr({ notas: modMemberNote }, `/members/${MemberId}`)).then(r => r && offlineMembersUpdate());
        setNoteEdit(false);
    }

    const debitVG = v => {
        if (!v) return '';
        if (typeof v === 'string') return v;
        return [...new Set(v || [])].toSorted().map(d => Debits[d] ? Debits[d].nombre : d).join(' - ');
    };

    function DebitSelector(p) {
        const { MemberDebits, MemberData, Debits, debitsChange } = p;
        const [checkedDebits, setCheckedDebits] = useState([...(MemberDebits || [])]);
        const [debitsDialog, setDebitsDialog] = useState(false);

        return (
            <
                >
                <Box
                    onClick={() => setDebitsDialog(true)}
                    sx={{ cursor: 'pointer' }}
                >
                    {!MemberDebits.length ?
                        (<small><i>Sin Debitos Asignados</i></small>) :
                        (MemberDebits || []).map(c => (
                            <Box
                                key={`DebitSelector-disabled-${c}`}
                            >
                                {Debits[c] ? Debits[c].nombre : c}
                            </Box>
                        ))
                    }
                </Box>
                {
                    debitsDialog ?
                        (<Dialog
                            open={debitsDialog}
                            onClose={() => setDebitsDialog(false)}
                            id="debit-assign-dialog"
                        >
                            <DialogTitle>
                                Asignar Débitos
                            </DialogTitle>
                            <DialogContent>
                                <Table
                                    stickyHeader
                                    size="small"
                                    sx={{
                                        '& td': { py: 1, border: 'none' },
                                        '& th': { fontWeight: 'bold' },
                                        '& td:first-of-type, & th:first-of-type': { px: 1, textAlign: 'center', minWidth: '5ch', fontWeight: 'normal' },

                                    }}
                                >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ fontSize: '.8em' }}>{checkedDebits.length ? `(${checkedDebits.length})` : ''}</TableCell>
                                            <TableCell>Concepto</TableCell>
                                            <TableCell>Monto</TableCell>
                                            <TableCell></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {Object.keys(Debits)
                                            .filter(deb => (!!Debits[deb] && !!Debits[deb].timestamp))
                                            .filter(deb => (!!MemberData.grupo_familiar || !Debits[deb].periodicidad.toLowerCase().includes('familiar')))
                                            .map(deb => (
                                                <TableRow
                                                    key={`NewDebitsDialog-${deb}`}
                                                    onClick={() => {
                                                        setCheckedDebits(checkedDebits.includes(deb) ? checkedDebits.filter(d => d !== deb) : [...checkedDebits, deb])
                                                    }}
                                                >
                                                    <TableCell>{checkedDebits.includes(deb) ? '🗹' : '☐'}</TableCell>
                                                    <TableCell>{Debits[deb].nombre}</TableCell>
                                                    <TableCell>${Debits[deb].importe}</TableCell>
                                                    <TableCell>{Debits[deb].periodicidad.replaceAll('/', '/ ')}</TableCell>
                                                </TableRow>
                                            ))
                                        }
                                    </TableBody>
                                </Table>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => setDebitsDialog(false)} color="error">Cancelar</Button>
                                <Button
                                    onClick={() => debitsChange(checkedDebits)}
                                    color="success">Grabar</Button>
                            </DialogActions>
                        </Dialog>)
                        : ''
                }
            </ >

        )
    }

    const [Columns] = useState([
        { field: 'socio', headerName: 'Socio', required: true, placeHolder: nextMember || '', type: 'number' },
        { field: 'catsocio', headerName: 'Cat. Socio', simple: true },
        { field: 'nombre', headerName: 'Nombre', required: true },
        { field: 'apellido', headerName: 'Apellido', required: true },
        { field: 'sobrenombre', headerName: 'Sobrenombre' },
        { field: 'documentonumero', headerName: 'DNI', required: true, type: 'number', simple: true },
        { field: 'matricula', headerName: 'Matricula' },
        { field: 'fnacimiento', headerName: 'Fecha Nac', type: 'date', simple: true, valueGetter: dateFix },
        { field: 'peso', headerName: 'Peso', type: 'number' },
        { field: 'altura', headerName: 'Altura', type: 'number' },
        { field: 'sexo', headerName: 'Sexo' },
        { field: 'telefono', headerName: 'Teléfono', simple: true },
        { group: 'direccion', groupHeader: 'Dirección' },
        { field: 'email', headerName: 'e-mail', group: 'direccion' },
        { field: 'direccion', headerName: 'Domicilio', group: 'direccion' },
        { field: 'ciudad', headerName: 'Ciudad', group: 'direccion' },
        { field: 'provincia', headerName: 'Provincia', group: 'direccion' },
        { field: 'codpostal', headerName: 'Cód. Postal', group: 'direccion' },
        { group: 'direccion' },
        { field: 'obrasoc', headerName: 'Obra Social' },
        { field: 'alergias', headerName: 'Alergias' },
        { field: 'gruposang', headerName: 'Grupo Sanguineo' },
        { field: 'contreferencia', headerName: 'Cont. Referencia', placeHolder: 'Nombre' },
        { field: 'contreferenciatel', placeHolder: 'Teléfono' },
        { field: 'contreferenciaref', placeHolder: 'Parentezco' },
        { groupHeader: 'Emergencia', group: 'emergencia' },
        { field: 'emertrasladar', headerName: 'Trasladar a', group: 'emergencia' },
        { field: 'emermedcabecera', headerName: 'Médico Cabecera', group: 'emergencia' },
        { field: 'emercirugias', headerName: 'Cirugías', group: 'emergencia' },
        { field: 'emerlesione', headerName: 'Lesiones', group: 'emergencia' },
        { field: 'emermedicamento', headerName: 'Toma Medicamento', group: 'emergencia' },
        { group: 'emergencia' },
        { groupHeader: 'Padres', group: 'padres' },
        { field: 'padrenombre', headerName: 'Padre', placeHolder: 'Nombre Completo', group: 'padres' },
        { field: 'padredni', placeHolder: 'DNI', group: 'padres' },
        { field: 'padretelefono', placeHolder: 'Teléfono', group: 'padres' },
        { field: 'padredomicilio', placeHolder: 'Domicilio', group: 'padres' },
        { field: 'padreemail', placeHolder: 'e-mail', group: 'padres' },
        { field: 'padreprofesion', placeHolder: 'Profesión', group: 'padres' },
        { field: 'madrenombre', headerName: 'Madre', placeHolder: 'Nombre Completo', group: 'padres' },
        { field: 'madredni', placeHolder: 'DNI', group: 'padres' },
        { field: 'madretelefono', placeHolder: 'Teléfono', group: 'padres' },
        { field: 'madredomicilio', placeHolder: 'Domicilio', group: 'padres' },
        { field: 'madreemail', placeHolder: 'e-mail', group: 'padres' },
        { field: 'madreprofesion', placeHolder: 'Profesión', group: 'padres' },
        { group: 'padres' },
        { groupHeader: 'Administración', group: 'administracion' },
        { field: 'cobrador', headerName: 'Cobrador', group: 'administracion' },
        { field: 'dircobro', headerName: 'Dirección Cobro', group: 'administracion' },
        { field: 'falta', headerName: 'Fecha Alta', group: 'administracion', type: 'date', valueGetter: dateFix },
        { field: 'fabaja', headerName: 'Fecha Baja', group: 'administracion', type: 'date', valueGetter: dateFix },
        { field: 'debitos', headerName: 'Débitos Aplicables', group: 'administracion', simple: true, valueGetter: debitVG, valueSetter: 'DebitSelector' },
    ]);

    useEffect(() => {
        let upload = Object.keys(modMemberData || {}).length > 0;
        for (let col of Columns)
            if (col.required && !modMemberData[col.field] && !MemberData[col.field])
                upload = false;
        setUploadEnabled(upload);
    }, [MemberData, modMemberData, Columns])

    return (
        <Box sx={{
            height: '100%',
            overflow: 'auto',
            py: 2,
        }}>
            {simpleView ?
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                    onClick={() => setSimpleView(false)}
                >
                    <Box
                        sx={{ fontSize: 24, fontWeight: 'bold' }}
                    >
                        {
                            MemberId === 'nuevo' ?
                                'Nuevo Socio'
                                :
                                `(${MemberData.socio || ''}) ${MemberData.nombre || ''} ${MemberData.apellido || ''}`
                        }
                        {!!MemberData.grupo_familiar && (
                            <IconButton
                                sx={{ ml: 1 }}
                                onClick={() => window.location.hash = `familia?${MemberData.grupo_familiar || ''}`}
                                title="Ver Grupo Familiar"
                            >
                                <PeopleIcon />
                            </IconButton>
                        )}
                    </Box>


                    <Table
                        size="small"
                        sx={{
                            width: 'auto',
                            '& .MuiTableCell-root': {
                                borderBottom: "none",
                                px: 1,
                                py: 0.5,
                            },
                            '& .MuiTableCell-root:first-of-type': {
                                textAlign: 'end'
                            },
                            '& .group-header': {
                                cursor: 'pointer'
                            },
                            '& .group-header .MuiTableCell-root:first-of-type': {
                                fontWeight: 'bold',
                                textAlign: 'start'
                            },
                            '& .group-header .MuiTableCell-root:last-of-type': {
                                fontWeight: 'bold',
                                textAlign: 'end',
                            },
                            '& input': {
                                py: 0,
                                px: 1,
                                fontSize: 14,
                            },

                        }}
                    >
                        <TableBody>
                            {Columns.filter(col => col.simple).map((col, index) =>
                                <TableRow key={`${col.field}-tablerow`}>
                                    <TableCell>{col.headerName ? `${col.headerName}:` : ''}</TableCell>
                                    <TableCell>{
                                        col.valueGetter ? col.valueGetter(MemberData[col.field] || '') : (MemberData[col.field] || '')
                                    }</TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </Box> :
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                    <Box
                        sx={{ fontSize: 24, fontWeight: 'bold' }}
                    >
                        {
                            MemberId === 'nuevo' ?
                                'Nuevo Socio'
                                :
                                `(${MemberData.socio || ''}) ${MemberData.nombre || ''} ${MemberData.apellido || ''}`
                        }
                        {!!MemberData.grupo_familiar && (
                            <IconButton
                                sx={{ ml: 1 }}
                                onClick={() => window.location.hash = `familia?${MemberData.grupo_familiar || ''}`}
                                title="Ver Grupo Familiar"
                            >
                                <PeopleIcon />
                            </IconButton>
                        )}
                    </Box>
                    <Table
                        size="small"
                        sx={{
                            width: 'auto',
                            '& .MuiTableCell-root': {
                                borderBottom: "none",
                                px: 1,
                                py: 0.5,
                            },
                            '& .MuiTableCell-root:first-of-type': {
                                textAlign: 'end'
                            },
                            '& .group-header': {
                                cursor: 'pointer'
                            },
                            '& .group-header .MuiTableCell-root:first-of-type': {
                                fontWeight: 'bold',
                                textAlign: 'start'
                            },
                            '& .group-header .MuiTableCell-root:last-of-type': {
                                fontWeight: 'bold',
                                textAlign: 'end',
                            },
                            '& input': {
                                py: 0,
                                px: 1,
                                fontSize: 14,
                            },

                        }}
                    >
                        <TableBody>
                            {Columns.map((col, index) =>
                                col.field ? (
                                    <TableRow key={`${col.field}-tablerow`}
                                        sx={!edit && col.group && !groupAccordion[col.group] ? { display: 'none' } : {}}
                                    >
                                        <TableCell>{col.headerName ? `${col.headerName}:` : ''}</TableCell>
                                        <TableCell>
                                            {(edit && !col.disabled) ?
                                                col.valueSetter === 'DebitSelector' ?
                                                    (<DebitSelector
                                                        MemberDebits={modMemberData.debitos || MemberData.debitos || []}
                                                        MemberData={MemberData}
                                                        Debits={Debits}
                                                        debitsChange={(data) => setModMemberData({ ...modMemberData, [col.field]: data })}
                                                    />)
                                                    : (<TextField
                                                        id={`${col.field}-textfield`}
                                                        variant="standard"
                                                        multiline={col.multiline}
                                                        required={col.required}
                                                        value={col.valueGetter ? col.valueGetter(MemberData[col.field] || '',2) : (MemberData[col.field] || '')}
                                                        onChange={(e) => setModMemberData({ ...modMemberData, [col.field]: e.target.value })}
                                                        placeholder={col.placeHolder || ''}
                                                        type={col.type || 'text'}
                                                        sx={col.required ? ({
                                                            backgroundColor: '#ff980050',
                                                            borderTopLeftRadius: 1,
                                                            borderTopRightRadius: 1,
                                                        }) : {}}
                                                    />) :
                                                col.valueGetter ? col.valueGetter(MemberData[col.field] || '') : (MemberData[col.field] || '')
                                            }
                                        </TableCell>
                                    </TableRow>) :
                                    col.groupHeader ? (
                                        <TableRow
                                            key={`${col.groupHeader}-tablegroupheader`}
                                            className="group-header"
                                            onClick={() => setGroupAccordion({ ...groupAccordion, [col.group]: !groupAccordion[col.group] })}
                                        >
                                            <TableCell >{col.groupHeader}</TableCell>
                                            <TableCell>{edit ? '' : (groupAccordion[col.group] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />)}</TableCell>
                                        </TableRow>
                                    ) :
                                        (
                                            <TableRow key={`${index}-tabledivider`}
                                                sx={!edit && col.group && !groupAccordion[col.group] ? { display: 'none' } : { borderBottom: '2px solid #ff980080' }}
                                            ><TableCell colSpan={2} /></TableRow>
                                        )

                            )}
                        </TableBody>
                    </Table>
                    <Box sx={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-evenly',
                        py: 2,
                    }}>
                        {(edit && MemberId && MemberId !== 'nuevo') ? <IconButton
                            aria-label="edit"
                            onClick={memberDelete}
                            disabled={MemberData.socio}
                        >
                            <DeleteForeverIcon color={MemberData.socio ? 'disabled' : 'error'} />
                        </IconButton> : ''}

                        {(MemberId && MemberId !== 'nuevo') ? <IconButton
                            aria-label="edit"
                            onClick={() => setEdit(!edit)}
                        >
                            {edit ? <EditOffIcon color="primary" /> : <EditSquareIcon />}
                        </IconButton> : ''}
                        {edit ? <IconButton
                            aria-label="edit"
                            onClick={storeMemberData}
                            disabled={!uploadEnabled}
                        >
                            <CloudUploadIcon color={uploadEnabled ? "success" : "disabled"} />
                        </IconButton> : ''}
                    </Box>
                </Box >
            }
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    maxWidth: '80%',
                    border: 'darkorange solid 1px',
                    borderRadius: '5px',
                    px: 1,
                    width: noteEdit ? '100%' : 'unset',
                    mx: 'auto',
                    my: 2,
                }}
            >
                <Box
                    sx={{ fontSize: 18, fontWeight: 'bold' }}
                    onClick={() => setNoteEdit(!noteEdit)}
                >
                    Notas
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        fontSize: 14,
                    }}
                >
                    {noteEdit ? (<TextField
                        multiline
                        id={`memberNote`}
                        variant="standard"
                        value={modMemberNote || ''}
                        onChange={(e) => setModMemberNote(e.target.value)}
                        placeholder={''}
                        type={'text'}
                        sx={{
                            backgroundColor: '#ff980050',
                            borderTopLeftRadius: 1,
                            borderTopRightRadius: 1,
                            width: '100%',
                            input: {
                                px: 1,
                            }
                        }}
                    />) : (
                        <Box
                            onClick={() => setNoteEdit(!noteEdit)}
                            sx={{
                                maxWidth: '100%',
                                whiteSpace: 'pre-line',
                            }}
                        >
                            {MemberData.notas || ''}
                        </Box>
                    )}
                    {
                        noteEdit ?
                            <IconButton
                                aria-label="edit"
                                onClick={storeMemberNote}
                            >
                                <CloudUploadIcon color="success" />
                            </IconButton>
                            : ''}
                </Box>
            </Box>
        </Box>
    )
}

export default MemberInfo;
